import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end gap-4",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = {
  type: "button",
  class: "btn btn-light-primary btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_update_logistics_doc"
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "mb-12" }
const _hoisted_9 = { class: "mb-14" }
const _hoisted_10 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_11 = { class: "fw-bold mb-6" }
const _hoisted_12 = { class: "mb-5 shipment-label-title" }
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "mb-12 me-6" }
const _hoisted_18 = { class: "mb-5 shipment-label-title" }
const _hoisted_19 = { class: "mb-5" }
const _hoisted_20 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "flex-1" }
const _hoisted_23 = { class: "mb-12" }
const _hoisted_24 = { class: "mb-5 shipment-label-title" }
const _hoisted_25 = { class: "mb-5" }
const _hoisted_26 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "mb-12" }
const _hoisted_29 = { class: "mb-5 shipment-label-title" }
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = { class: "flex-1" }
const _hoisted_32 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_33 = { class: "flex-1" }
const _hoisted_34 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_35 = { class: "mb-12" }
const _hoisted_36 = { class: "mb-5 shipment-label-title" }
const _hoisted_37 = { class: "d-flex flex-wrap" }
const _hoisted_38 = { class: "mb-5 w-50 pe-6" }
const _hoisted_39 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_40 = { class: "mb-5 w-50 pe-6" }
const _hoisted_41 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_42 = { class: "mb-5 w-50 pe-6" }
const _hoisted_43 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_44 = { class: "mb-5 w-50 pe-6" }
const _hoisted_45 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_46 = { class: "mb-12" }
const _hoisted_47 = { class: "mb-5 shipment-label-title" }
const _hoisted_48 = { class: "d-flex flex-wrap" }
const _hoisted_49 = { class: "mb-5 w-50 pe-6" }
const _hoisted_50 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_51 = { class: "mb-5 w-50 pe-6" }
const _hoisted_52 = { class: "fw-semibold fs-6 text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditShipmentLabel = _resolveComponent("EditShipmentLabel")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.t("shipmentLabel.edit")), 1)
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("shipmentLabel.shipmentLabelAlarmLimit")) + " : ", 1),
          _createElementVNode("div", null, "≤" + _toDisplayString(_ctx.showData.logistics_limit), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.t("shipmentLabel.shipmentLabelDetail")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.t("shipmentLabel.freightPayer")), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("shipmentLabel.calculateTransportCostsFor")) + " : ", 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.showData.company_name), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.t("shipmentLabel.shipper")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("shipmentLabel.shipper")) + " : ", 1),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: "mb-0",
                  innerHTML: _ctx.showData.sender_address
                }, null, 8, _hoisted_21)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.t("shipmentLabel.recipient")), 1),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("shipmentLabel.recipient")) + " : ", 1),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: "mb-0",
                  innerHTML: _ctx.showData.recipient_address
                }, null, 8, _hoisted_27)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.t("shipmentLabel.mandatoryInformationRate")), 1),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t("shipmentLabel.rate")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.service_type), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.t("shipmentLabel.pickup")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.pick_up_date), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.t("shipmentLabel.packageDetails")), 1),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.t("shipmentLabel.LWH")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.package_size_l) + " / " + _toDisplayString(_ctx.showData.package_size_w) + " / " + _toDisplayString(_ctx.showData.package_size_h), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t("shipmentLabel.totalWeight")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.package_weight), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.t("shipmentLabel.packaging")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.package_type), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.t("shipmentLabel.contents")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.interior_category), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.t("shipmentLabel.additioninformationComments")), 1),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.t("shipmentLabel.sendInformationTo")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.email), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.t("shipmentLabel.commentsInstructions")) + " : ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.showData.notes), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_EditShipmentLabel, {
      showData: _ctx.showData,
      originalData: _ctx.originalData,
      onUpdateList: _ctx.updateList
    }, null, 8, ["showData", "originalData", "onUpdateList"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}